// extracted by mini-css-extract-plugin
export var avatarContainer = "_b6-0";
export var avatarTypingWave = "_b6-i";
export var gray = "_b6-f";
export var green = "_b6-c";
export var icon = "_b6-9";
export var image = "_b6-1";
export var lg = "_b6-6";
export var md = "_b6-5";
export var presenceDot = "_b6-b";
export var red = "_b6-d";
export var sm = "_b6-4";
export var status = "_b6-a";
export var typingDot = "_b6-h";
export var typingPill = "_b6-g";
export var xl = "_b6-7";
export var xs = "_b6-3";
export var xxl = "_b6-8";
export var xxs = "_b6-2";
export var yellow = "_b6-e";